import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  scorePenalityDefsData: {
    "data": []
  }
};

export const scorePenalityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SCORE_PENALITY_DEF_DATA:
      return {
        ...state,
        scorePenalityDefsData: action.payload,
      };

      case actionTypes.UPDATE_SCORE_PENALITY_DEF_DATA:
      return {
        ...state,
        scorePenalityDefsData: action.payload,
      };
    default:
      return state;
  }
};
